export default "__VITE_ASSET__Bn2$$2Y___"